import React from 'react';

import type { ClaimNotificationModel, UpdateNotification } from '~/components/ClaimNotificationsCard/types';
import CategoryEditableChipBase from '~/components/core/Molecules/CategoryEditableChipBase';
import useOrganization from '~/components/OrganizationContext';
import type { Category } from '~/server_shared/swagger/data-contracts';

interface CategoryEditableChipProps {
  claimNotification: ClaimNotificationModel;
  disabled?: boolean;
  setIsUpdating: (isUpdating: boolean) => void;
  onUpdate: UpdateNotification;
  className?: string;
}

const CategoryEditableChip: React.FC<CategoryEditableChipProps> = ({
  claimNotification,
  disabled,
  setIsUpdating,
  onUpdate,
  className,
}) => {
  const { notificationCategories, isLoadingNotificationCategories, isErrorNotificationCategories } =
    useOrganization() as {
      notificationCategories: Category[];
      isLoadingNotificationCategories: boolean;
      isErrorNotificationCategories: boolean;
    };

  return (
    <CategoryEditableChipBase
      entity={claimNotification}
      categories={notificationCategories}
      isLoading={isLoadingNotificationCategories}
      isError={isErrorNotificationCategories}
      apiEndpoint={`/api/v1/notifications/${claimNotification.id}/categories`}
      disabled={disabled}
      setIsUpdating={setIsUpdating}
      onUpdate={onUpdate}
      className={className}
    />
  );
};

export default CategoryEditableChip;
